<template>
  <div class="c-contentsExampleDetail">
    <a
      @click="expanded = !expanded"
      class="c-contentsExampleDetailIndex"
      v-if="message.userMessage"
    >
      <div class="c-contentsExampleDetailIndex_icon">
        <div class="c-contentsExampleDetailIndex_iconInner">
          <coconala-icon
            name="comment-w"
            size="16px"
          />
        </div>
      </div>
      <div class="c-contentsExampleDetailIndex_caption">
        {{ generateUserMessageIndex }}
      </div>
      <div class="c-contentsExampleDetailIndex_readMore">
        <span v-if="isPC || isTB">詳細を見る</span>
        <coconala-icon
          :name="expanded ? 'chevron-up' : 'chevron-down'"
          size="11px"
        />
      </div>
    </a>
    <div
      class="c-contentsExampleDetailContents"
      v-if="expanded"
    >
      <div class="c-contentsExampleDetailContents_user c-user">
        <div class="c-user_message">
          <div v-text="message.userMessage"></div>
        </div>
        <div class="c-user_icon">
          <div class="c-userIconInner">
            <div class="c-userIconInner_item">
              <coconala-icon
                name="user"
                size="20px"
              />
            </div>
            <div class="c-userIconInner_item">
              <span>購入者</span>
            </div>
          </div>
        </div>
      </div>
      <div class="c-contentsExampleDetailContents_provider c-provider">
        <div class="c-provider_icon">
          <div class="c-providerIconInner">
            <div class="c-providerIconInner_item">
              <coconala-icon
                name="user"
                size="20px"
              />
            </div>
            <div class="c-providerIconInner_item">
              <span>出品者</span>
            </div>
          </div>
        </div>
        <div class="c-provider_message">
          <div v-text="message.providerMessage"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

const USER_MESSAGE_INDEX_LENGTH = 38

export default {
  name: 'ContentsExampleDetail',
  props: {
    message: {
      type: Object,
      default: () => ({
        userMessage: '',
        providerMessage: ''
      })
    }
  },
  data() {
    return {
      expanded: false
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC', 'isTB']),
    generateUserMessageIndex() {
      const noLineBreak = this.message.userMessage.replace(/\r?\n/g, '')
      return this.$util.truncate(noLineBreak, USER_MESSAGE_INDEX_LENGTH)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-contentsExampleDetailIndex {
  display: flex;
  padding: 16px 0;
  height: 64px;
  overflow: hidden;
  border-bottom: 1px solid $color-gray-200;
  color: $color-gray-900;
  @include link-effect;

  &_icon {
    align-self: center;
    flex-basis: 32px;
    margin-right: 8px;
  }

  &_iconInner {
    display: flex;
    color: $color-blue-500;
    height: 32px;
    width: 32px;
    background: $color-gray-50;
    border-radius: 16px;

    i {
      align-self: center;
      margin: 0 auto;
    }
  }

  &_caption {
    align-self: center;
    flex: 1 1 auto;
  }

  &_readMore {
    align-self: center;
    flex: 0 0 100px;
    width: 100px;
    text-align: right;
    color: $color-link-base;
  }
}

.c-contentsExampleDetailContents {
  padding: 24px 16px;
  background: $color-gray-50;

  &_user {
    margin-bottom: 8px;
  }
}

.c-user {
  display: flex;

  &_message {
    position: relative;
    background: $color-blue-500;
    padding: 16px 24px;
    color: $color-white;
    font-size: 14px;
    border-radius: 6px;
    white-space: pre-wrap;
    word-wrap: break-word;
    margin-left: 48px;
    flex: 1 1 auto;

    &::after {
      content: '';
      height: 0;
      width: 0;
      pointer-events: none;
      position: absolute;
      border: solid transparent;
      border-top-width: 4px;
      border-bottom-width: 4px;
      border-left-width: 5px;
      border-right-width: 5px;
      border-left-color: $color-blue-500;
      left: 100%;
      top: 15px;
    }
  }

  &_icon {
    margin-left: 16px;
    flex-basis: 48px;
  }
}

.c-userIconInner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 48px;
  width: 48px;
  border-radius: 24px;
  background: $color-white;
  font-size: 10px;

  &_item {
    text-align: center;
    line-height: 1;

    i {
      color: $color-blue-500;
      margin-bottom: 4px;
    }
  }
}

.c-provider {
  display: flex;

  &_message {
    position: relative;
    background: $color-white;
    padding: 16px 24px;
    color: $color-gray-900;
    font-size: 14px;
    border-radius: 6px;
    white-space: pre-wrap;
    word-wrap: break-word;
    margin-right: 48px;
    flex: 1 1 auto;

    &::after {
      content: '';
      height: 0;
      width: 0;
      pointer-events: none;
      position: absolute;
      border: solid transparent;
      border-top-width: 4px;
      border-bottom-width: 4px;
      border-left-width: 5px;
      border-right-width: 5px;
      border-right-color: $color-white;
      right: 100%;
      top: 15px;
    }
  }

  &_icon {
    margin-right: 16px;
    flex-basis: 48px;
  }
}

.c-providerIconInner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 48px;
  width: 48px;
  border-radius: 24px;
  background: $color-white;
  font-size: 10px;

  &_item {
    text-align: center;
    line-height: 1;

    i {
      color: $color-green-500;
      margin-bottom: 4px;
    }
  }
}

@media (max-width: breakpoint(ServiceDetail, M)) {
  .c-contentsExampleDetailIndex {
    padding: 0 12px;
  }
}

@media (max-width: breakpoint(ServiceDetail, S)) {
  .c-contentsExampleDetailIndex {
    &_readMore {
      flex: 0 0 20px;
      width: 20px;
    }
  }

  .c-user {
    &_message {
      margin-left: 0;
    }
  }

  .c-provider {
    &_message {
      margin-right: 0;
    }
  }
}
</style>
